import React, { useState } from 'react';

import { ProductContentLiveMeetingItemResponse, ProductsEvolutionLiveCard } from 'features/products';
import styled from 'styled-components';
import { Box, ButtonIcon, Flex, ProgressBar, Typography } from 'components';

interface LivesEvolutionCardProps {
  lives: ProductContentLiveMeetingItemResponse[];
  liveCompletionPercentage: number;
}

const Wrapper = styled(Flex)`
  ${(props: any) => {
    if (props['data-opened']) {
      return `
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      `;
    }

    return `
      border-radius: 4px;
    `;
  }}
`;

const LivesEvolutionCard = ({ lives, liveCompletionPercentage }: LivesEvolutionCardProps) => {
  const [opened, setOpened] = useState(false);

  return (
    <Flex flexDirection="column">
      <Wrapper data-opened={opened} bg="white" mt={2} flexWrap="nowrap" justifyContent="space-between">
        <Flex flexDirection="column">
          <Typography
            type="type2"
            color="gray_600"
            fontWeight="bold"
            pt={{ m: 2, t: 3 }}
            px={{ m: 2, t: 3 }}
            onClick={() => setOpened(!opened)}
            style={{ cursor: 'pointer' }}
          >
            Aulas ao vivo
          </Typography>

          <Flex flexGrow={0} flexWrap="nowrap" alignItems="center" pt={1} pb={2} px={3}>
            <Box flexGrow={0} flexShrink={0} width={40}>
              <Typography type="type1" color="primary_400" fontWeight="bold">
                {`${liveCompletionPercentage}%`}
              </Typography>
            </Box>

            <Flex maxWidth={412}>
              <ProgressBar percent={liveCompletionPercentage} />
            </Flex>
          </Flex>
        </Flex>

        <Flex flexGrow={0} pr={3}>
          <ButtonIcon
            icon={opened ? 'chevronUp' : 'chevronDown'}
            bg="transparent"
            color={'primary_400'}
            iconWidth={25}
            onClick={() => setOpened(!opened)}
            width={30}
          />
        </Flex>
      </Wrapper>

      {opened && (
        <Flex bg="gray_100" borderBottomLeftRadius={4} borderBottomRightRadius={4} flexDirection="column">
          {lives.map((live, index) => {
            return <ProductsEvolutionLiveCard live={live} index={index} />;
          })}
        </Flex>
      )}
    </Flex>
  );
};

export default LivesEvolutionCard;
